<template>
<div class="container-fluid p-0 justify-content-center d-flex">
  <section class="resume-section p-3 p-lg-5
   d-flex align-items-center text-center" id="interests">
    <div class="w-100">
      <h2 class="mb-5">Interests</h2>
      <p>Apart from being a mobile &amp; web developer,
        I enjoy most of my time being indoors because 365 days of summer. Travel almost every continent in world,
         and Mingle around developer communities,
        is part of my enjoyment and self-improvement.
        I like to support web fast and widely supported, esp. <strong>
          performance, best practices and accessibility</strong>.
        </p>
      <p>
      When indoors (like very much), I follow a number of sci-fi and
      fantasy genre movies (wanna see my movie list <router-link to="/sc-movies">here?</router-link>)
       and decent anime shows,<strike> I am the one who cooks</strike> I like to learn cooking,
       while I spend a large amount
      of my free time exploring the latest technology
      advancements in the front-end web development world.</p>

      <p>Music? Hardbass for life</p>

    </div>
  </section>
  </div>
</template>

<script>
export default {
  name: 'interests',
};
</script>

<style>
#interests{
max-width: 900px;
}
</style>
